import React, { useEffect, useState } from "react";
import { HeartIcon } from "@heroicons/react/24/solid";
import { useBrandTokenStyle } from '@charitystack/design-tokens/provider';
import { generateBrandColors, safePostMessageToParent } from '@charitystack/shared';
// Shine animations now in shared-styles/animations.css

const freqMap = {
  "": "",
  ONE_TIME: "One-Time",
  DAILY: "Daily",
  WEEKLY: "Weekly",
  MONTHLY: "Monthly",
  ANNUALLY: "Yearly",
};

function DonationFlag(props) {
  const [elementID, setElementID] = useState("");
  const [loading, setLoading] = useState(!props.previewMode);

  const [destinationURL] = useState(
    import.meta.env.VITE_HOSTED_PAGE_URL || "https://charitystack.com/donate"
  );
  const [color, setColor] = useState(props.previewMode ? props.color || "#538CAC" : "#538CAC");
  const [orientation, setOrientation] = useState(props.previewMode ? props.orientation || "TOP" : "TOP");
  const [destinationType, setDestinationType] = useState(props.previewMode ? props.destinationType || "POPUP" : "POPUP");

  useEffect(() => {
    // Skip URL param fetching in preview mode
    if (props.previewMode) {
      return;
    }

    const urlParams = new URLSearchParams(window.location.search);
    const elementID = urlParams.get("elementID");
    setColor(urlParams.get("color"));
    setOrientation(urlParams.get("orientation"));
    setLoading(false);
    setElementID(elementID);
    setDestinationType(urlParams.get("destinationType"));

  }, [props.previewMode]);

  // Update color when prop changes in preview mode
  useEffect(() => {
    if (props.previewMode && props.color) {
      setColor(props.color);
    }
  }, [props.previewMode, props.color]);

  // Update orientation when prop changes in preview mode
  useEffect(() => {
    if (props.previewMode && props.orientation) {
      setOrientation(props.orientation);
    }
  }, [props.previewMode, props.orientation]);

  const handleClick = () => {
    // Disable click in preview mode
    if (props.previewMode) {
      return;
    }
    console.log("[DonationFlag] destinationType:", destinationType);
    if (destinationType == "POPUP") {
      const popupMessage = {
        action: "SHOW_OVERLAY_ELEMENT",
        entity: "CHARITYSTACK",
        sender: "DONATION_FLAG",
        receiver: "HOSTED_SCRIPT",
        elementID: elementID,
      };
      console.log("[DonationFlag] Sending SHOW_OVERLAY_ELEMENT postMessage:", popupMessage);
      safePostMessageToParent(popupMessage, "*");
    } else {
      const urlParams = new URLSearchParams(window.location.search);
      const redirectMessage = {
        action: "REDIRECT",
        entity: "CHARITYSTACK",
        sender: "DONATION_FLAG",
        receiver: "HOSTED_SCRIPT",
        data: JSON.stringify({
          elementID: elementID,
          destinationURL: urlParams.get("destinationURL") || destinationURL,
        }),
      };
      console.log("[DonationFlag] Sending REDIRECT postMessage:", redirectMessage);
      safePostMessageToParent(redirectMessage, "*");
    }
  };


  // G73-0: the flag paints the brand ACTION role and its label + heart the
  // brand FOREGROUND role (near-black on light brands, SPEC §A). The roles are
  // written inline on the button itself, so the dashboard's preview of this
  // component never brands the dashboard around it.
  const brandTokenStyle = useBrandTokenStyle({ color, expand: generateBrandColors });

  return (
    <button
      type="button"
      className={`flex h-10 w-28 overflow-hidden gap-[var(--cs-space-2)] px-[var(--cs-space-4)] ${props.previewMode ? 'cursor-default' : 'cursor-pointer'} select-none items-center justify-center rounded-[var(--cs-control-radius)] border-0 bg-[color:var(--cs-brand-action,var(--cs-text-primary))] text-[color:var(--cs-brand-foreground,var(--cs-surface-0))] focus-visible:[outline:var(--cs-focus-outline)] focus-visible:[outline-offset:calc(var(--cs-focus-outline-offset)*-1)] ${
        orientation == "TOP" ? "rounded-t-none" : "rounded-b-none"
      }`}
      style={{ ...brandTokenStyle, '--flag-text-color': 'var(--cs-brand-foreground, var(--cs-surface-0))' }}
      onClick={handleClick}
    >
      <div className="text-[length:var(--cs-text-sm)] font-semibold leading-[var(--cs-leading-20)]">Donate</div>
      <div className="relative flex items-center justify-center">
        {/* Ripple rings - centered on heart */}
        <span className="donation-flag-ripple" />
        {/* Pulsing heart */}
        <HeartIcon aria-hidden="true" className="size-[var(--cs-icon)] donation-flag-heart" />
      </div>
    </button>
  );
}

export default DonationFlag;
